import "./Footer.less";

import React, { Component } from "react";
import i18n from "i18next";
import { translate } from "react-i18next";

const FOOTER_URLS = {
	nl: {
		privacy: "https://www.plantyn.com/web/nl/uitgeverij-plantyn/plantyn/privacy",
		impressum: "https://www.plantyn.com/web/nl/uitgeverij-plantyn/plantyn/privacy"
	},
	fr: {
		privacy: "https://www.plantyn.com/web/fr/editions-plantyn/conditions-generales",
		impressum: "https://www.plantyn.com/web/fr/editions-plantyn/conditions-generales"
	}
};

class Footer extends Component {

	render() {
		const t = this.props.t;

		return (
			<footer>
				<div className="left">
					<p>{t("allRights")}</p>
				</div>
				<div className="right">
					{ /* <a href={FOOTER_URLS[i18n.language].impressum}>{t("impressum")}</a> */}
					<a href={FOOTER_URLS[i18n.language].privacy} target="_blank">{t("privacy")}</a>
					<a data-toggle="modal" data-target="#termsmodal" href="#">
						{t("terms")}
					</a>
				</div>
			</footer>
		);
	}
}

const translateFooter = translate("footer")(Footer);

export { translateFooter as Footer }



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js